/* ============================================================
   config.js  —  CHANGE ALL YOUR WEDDING DETAILS HERE
   This is the only file you need to edit for basic setup
   ============================================================ */

import leteise from "../assets/photos/leteise.jpg";
import storyphoto1 from "../assets/photos/proposal2.jpeg";
import storyphoto2 from "../assets/photos/proposal8.jpeg";
import storyphoto3 from "../assets/photos/proposal9.jpeg";
import storyphoto6 from "../assets/photos/engagementring.jpeg";
import weddingRing from "../assets/photos/wedding-ring.png";

export const WEDDING = {
  /* ── NAMES ── change these */
  groomName: "Mbatshi",
  brideName: "Olorato",
  surname: "",
  surnamegroom: "Mudanga",
  surnamebride: "Ebineng",
  initials: "M & O",

  /* ── DATES ── format: 'YYYY-MM-DDTHH:MM:SS' */
  countdownDate: "2026-09-11T08:00:00",
  // ── PROPOSAL VIDEO UNLOCK DATE ──────────────────────────
  // The proposal video is HIDDEN until this exact date & time.
  // Guests who visit before this date see a locked screen with a countdown.
  // Guests who visit ON or AFTER this date see the video automatically.
  //
  // Format: 'YYYY-MM-DDTHH:MM:SS'
  // Examples:
  //   '2025-09-19T14:00:00'  → unlocks on 19 Sep 2025 at 2:00 PM
  //   '2025-09-19T00:00:00'  → unlocks at midnight on wedding day
  //   '2025-12-25T09:00:00'  → unlocks Christmas morning
  //
  // ← CHANGE THIS DATE TO WHATEVER YOU WANT ↓
  videoUnlockDate: "2026-09-12T08:00:00",
  rsvpDeadline: "30 August 2026",

  /* ── LOCATION ── */
  city: "Gaborone",
  country: "Botswana",
  website: "https://www.mbatshioloratowedding.horizondatabw.com/",

  /* ── VENUES ── */
  PatloVenue: "Serowe Makolojwane",
  rusticVenue: "Serowe Makolojwane",
  receptionVenue: "Mokolodi Gaborone",
  cultureVenue: "Gaborone North",
  //hotelBlock: "TBC",
  //shuttlePickup:     'Sheraton Hotel lobby',
  //accommodationCode: "TBC",
  bookingDeadline: "30 August 2026",

  /* ── STORY TEXT ── */
  storyParagraph1: `
Some love stories begin with fireworks.
Ours began with two people accidentally crossing paths in a quiet little village called XXX...

Was it fate? Coincidence? Or did someone get "lost" on purpose? We'll let you decide.

That's all we're revealing... for now! 😉

To be continued...`,
  storyParagraph2: `
Fast forward to July 2025...

With butterflies, a racing heart, and the ring in the right pocket, Mbatshi went down on one knee in XXX and asked XXXX the easiest question she'd ever answer.

She said "YES!"

Now, the next chapter is about to begin... and we'd be honoured to have you there as we turn the page together.`,

  /* ── BIO TEXT ── */
  groomBio: `
  Mbatshi.....
  
\n\nA quiet, shy Kalanga teddy bear... at least until you get to know him.

\n\nKind hearted, loyal, loving, and God fearing, he's the kind of person who would rather listen than talk unless the conversation is about tech, data, AI, or other things he pretends to understand! He finds comfort in talking to God, whether life is challenging or full of joy. 
Dependable, humble, and always ready to lend a helping hand, Mbatshi's a friend everyone can count on. And yes... he still believes his jokes deserve a standing ovation.

\n\nThere's more to discover about him...
🤫 To be continued...`,
  brideBio: `
  
Olorato.....
  
A Mongwato born queen with beauty, grace, and a heart to match.

Compassionate, loving, faithful, focused, and full of warmth, she lights up every room she walks into. Beautiful inside and out, she carries a heart big enough for everyone she meets. 
She pretends to be shy… until she’s comfortable then the joy, wit, and confidence come alive.

\n\nHer name, Olorato, means “love”, and it perfectly reflects her character.

\n\nStrong in faith and guided by God, she brings wisdom beyond her years and somehow keeps life in order… especially him. 
Strong, graceful, and determined in everything she does, she is truly one of a kind.

\n\nHer story has only just begun...
🤫 To be continued...`,

  /* ── MESSAGE FROM US ── */
  message: `"To our dearest family and friends- thank you for being part of our lives.
Every prayer, every meal, every visit, every word of encouragement… we carry it all with us into this marriage. We didn’t get here alone. We got here because of you,  your love, support, and presence. 
So this isn’t just our celebration… it’s ours. A moment shared with the people who shaped our journey.

Thank you for coming to witness our story. Now let’s celebrate and make it unforgettable together."`,

  /* ── MUSIC track display names ── */
  tracks: ["God's timing gave me you — Justin Gavin"],
  //import { WEDDING } from "../assets/proposal.mp4.jpg";

  /* ── LINKS ── paste your real URLs here, or leave null ── */
  googleFormUrl: null, // "https://docs.google.com/forms/d/e/1FAIpQLScKqn_VOPglp4jUAZjxtEe-nMyjI6Tq6KnsHD8kt9KKLvIUxw/formResponse",

  driveUploadUrl:
    "https://drive.google.com/drive/folders/1SrbCuE10h1bTuhJLywI4HFWVv-E5SnaW",
  videoUrl: null,
  videoType: "mp4", // 'vimeo' | 'drive' | 'mp4'
  cashGiftUrl: null,
  voucherUrl: null,
  registryUrl: null,
};

/* ── EVENTS ── */
export const EVENTS = [
  {
    day: "11",
    month: "Sep",
    name: "Patlo, Magadi Pholoso",
    badge: "Traditional Attire",
    badgeBg: "#E5D5A5",
    badgeColor: "#6B4C10",
    bar: "linear-gradient(90deg,#C5A05A,#E5D5A5)",
    icon: "🐂",
    detail:
      "Friday · from 5:00 AM\n Ebineng Family Homestead in Makolojwane, Serowe\nA sacred family gathering the Mbatshi's family approaches the Zizi's family to honour and negotiate the bride price. Traditional attire required.",
  },
  {
    day: "12",
    month: "Sep",
    name: "Wedding Lucheon",
    badge: "Rustic Sage",
    badgeBg: "#F5ECD5",
    badgeColor: "#7A5C1E",
    bar: "linear-gradient(90deg,#9B7B1A,#C5A05A)",
    icon: (
      <img
        src={weddingRing}
        alt="Wedding ring"
        style={{ width: "40px", height: "40px", objectFit: "contain" }}
      />
    ),
    detail:
      "Saturday · 09:00 AM — Late\nSerowe Home, Serowe\n\nRustic outdoor celebration under the stars. Lanterns, fire, laughter and good food. Earthy linen tones, bare feet on grass.",
  },
  {
    day: "19",
    month: "Sep",
    name: "Evening Wedding",
    badge: "All black (Black Tie)",
    badgeBg: "#DFF0DC",
    badgeColor: "#3E6642",
    bar: "linear-gradient(90deg,#152018,#243C28)",
    icon: "🥂",
    detail:
      "Saturday · Reception 1:00 PM\nMokolodi\n\nFormal wedding ceremony followed by an elegant black-tie reception. Please be seated by 2:00 PM.",
    highlight: true,
  },
  {
    day: "20",
    month: "Sep",
    name: "Kgoroso",
    badge: "Cultural",
    badgeBg: "#B8E8DA",
    badgeColor: "#243C28",
    bar: "linear-gradient(90deg,#6B9B6F,#7ECFB8)",
    icon: "🤝",
    detail:
      "Sunday · 9:00 AM — 13:00 PM\nMbatshi Family Homestead, Gaborone\n\nTraditional attire, Kalanga songs, family blessings, and kalanga cuisine. Our heritage woven into our future.",
  },
];

/* ── DRESS CODES ── */
export const DRESS_CODES = [
  {
    date: "11 September · Friday",
    title: "Traditional Attire",
    swatches: [],
    note: "Full traditional dress for Lobola negotiations. Please represent your culture with pride.",
  },
  {
    date: "12 September · Saturday",
    title: "Rustic & Sage",
    swatches: ["#6B7355", "#8E9B7A", "#96784E", "#B07A72", "#EDE0E0"],
    note: "Earthy tones, linen, cotton",
  },
  {
    date: "19 September · Saturday",
    title: "All black (Black Tie)",
    swatches: ["#0D0D0D"],
    note: "Tuxedos, suits, and gowns.",
  },
  {
    date: "20 September · Sunday",
    title: "Kgoroso",
    //swatches: ["#6B9B6F", "#7ECFB8", "#C5A05A", "#A8C5A0"],
    images: [leteise],
    note: "Leteisie or smart cultural outfit.",
  },
];

/* ── FAQ ── */
export const FAQS = [
  [
    "Who to contact for more information?",
    "Ponalo kgobe -71 636 539 (Serowe)-- \n\n Kese Pitso - 71 694 411 (Gaborone)\n\n Kuda Batlegang - 71 404 416 (Gaborone)",
  ],
  [
    "Do I need to attend all four events?",
    "The celebrations on the 11th, 12th, and 20th are open to all guests. \nThe 20th is our short Kgoroso celebration, where we officially receive the bride. \n The 19th is our wedding reception and is strictly by invitation and RSVP only.",
  ],
  [
    "Can I bring my children?",
    "We love children but after much thought, we have decided to keep our celebration adults only, as the setting and environment may not be conducive or safe for little ones.",
  ],
  [
    "What is Lobola?",
    "Lobola is a cherished African tradition where the groom's family approaches the bride's family with gifts to honour their daughter. It is a symbol of respect, love, and commitment, and it strengthens the bond between families.",
  ],
  [
    "What time should I arrive on 19 September?",
    "Arrival is between 1-2:00 PM. Please be seated by 2:00 PM for the ceremony start.",
  ],
  [
    "Can I bring a plus one?",
    "All dates except the 19th are welcome to have plus ones 😊. Kindly note that  the 19th is strictly by RSVP. If you would like to bring a plus one, please kindly reach out to the newlyweds in advance so arrangements can be made accordingly.\nWe truly appreciate your understanding and support in respecting this arrangement.\nWe can’t wait to celebrate the day with you. 💛",
  ],
  [
    "Can I take photos during the ceremony?",
    "We're having an unplugged ceremony. Scan the QR code to upload your photos to our shared album!",
  ],
];

/* ── STORY PHOTOS ──
   To use real photos, replace `bg` with:
   photo: require('../assets/photos/your-photo.jpg')
   Then in OurStory.js use: backgroundImage:`url(${p.photo})` instead of background:p.bg

*/

/* ── GALLERY / SLIDESHOW LINKS ──
   Full-resolution photo galleries & slideshows for each event,
   hosted on Google Photos. Shown as a "View Full Gallery" button
   inside each event's Gallery modal.
*/
export const GALLERY_LINKS = {
  proposal: "https://photos.app.goo.gl/ibq79p1KoGFrnjoK6",
  lobola: "https://photos.app.goo.gl/ZBpqRqiNqcMgbCQFA",
  rustic: "https://photos.app.goo.gl/yDSqZ4hUDHfBkri67",
  reception: "https://photos.app.goo.gl/HxuD9ATGYuvXghSf8",
  culture: "https://photos.app.goo.gl/6suYGGwAHR2KjmeP8",
  guests: "https://photos.app.goo.gl/Kzh1uQaqCSbFvscn8",
};

/* ── GALLERY QR CODES ──
   [EDIT] Generate each QR at qr.io using the matching Google Photos
   link below, download as PNG, save into src/assets/qr/, then the
   paths below will pick them up.
   If a QR is not ready yet, leave it as null — a placeholder shows.
*/
export const GALLERY_QR = {
  lobola: require("../assets/qr/lobola.png"),
  rustic: require("../assets/qr/rustic.png"),
  reception: require("../assets/qr/reception.png"),
  culture: require("../assets/qr/culture.png"),
};

export const STORY_PHOTOS = [
  {
    photo: storyphoto1,
    //icon: "💍",
    label: "The Proposal",
    // sub: "South Africa · July 2025",
    tall: true,
  },
  {
    photo: storyphoto2,
    //icon: "📚",
    label: "Getting ready for proposal",
    //sub: "2023",
  },
  {
    photo: storyphoto3,
    //icon: "🌿",
    label: "On 1 knee",
    //sub: "2023",
  },
  {
    photo: storyphoto6,
    //icon: "🌅",
    label: "Engagement Ring",
    tall: true,
    //sub: " 2025",
  },
];
